import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setQliroCustomerInfo } from '../../Actions/Checkout.action';
import { dataLayerGtmCheckoutUpdate } from '../../Services/Gtm.service';

const CheckoutWidget = ({
  extractScripts,
  executeScript,
  includeScript,
  paymentSession,
}) => {
  const dispatch = useDispatch();
  const extractScriptsResult = extractScripts(paymentSession);
  const firstRender = useRef(true);
  const {
    checkout: {
      payload: { qliroCustomerInfo },
    },
    cart,
  } = useSelector((state) => state);

  useEffect(() => {
    // Make sure it is executed only once.
    // firstRender is used to prevent eslint warning when having empty dependencies array
    if (!firstRender.current) {
      return;
    }
    firstRender.current = false;
    extractScriptsResult.scripts &&
      extractScriptsResult.scripts.forEach((script) =>
        executeScript('checkout-widget', script)
      );
    extractScriptsResult.scriptFiles &&
      extractScriptsResult.scriptFiles.forEach((url) =>
        includeScript('checkout-widget', url)
      );

    window.q1Ready = function (q1) {
      q1.onCustomerInfoChanged((customer) => {
        dispatch(setQliroCustomerInfo(customer));
      });
    };
  }, [executeScript, includeScript, extractScriptsResult]);

  useEffect(() => {
    dataLayerGtmCheckoutUpdate(qliroCustomerInfo, cart);
  }, [qliroCustomerInfo, cart]);

  return (
    <div
      id="checkout-widget"
      dangerouslySetInnerHTML={{ __html: extractScriptsResult.html }}
    />
  );
};

export default CheckoutWidget;
